import { z } from 'zod';

import { resultsTourGeneralCo2DtoSchema } from './co2/dto.type';
import { resultsTourGeneralEnvDtoSchema } from './env/dto.type';
import { resultsTourGeneralEssDtoSchema } from './ess/dto.type';

export type ResultsTourDto = z.infer<typeof resultsTourDtoSchema>;

const globalDtoSchema = z.object({
  co2: z
    .object({
      score: z.number(),
    })
    .optional(),
});

const generalDtoSchema = z.object({
  co2: resultsTourGeneralCo2DtoSchema,
  env: resultsTourGeneralEnvDtoSchema,
  ess: resultsTourGeneralEssDtoSchema,
});

const ontourDtoSchema = z.object({
  co2: z
    .object({
      score: z.number(),
    })
    .optional(),
  sequences: z.array(
    z.object({
      id: z.number(),
      results: z.object({
        co2: z.object({
          score: z.number(),
          events: z.number(),
          travels: z.number(),
          variousCost: z
            .object({
              score: z.number(),
              sectors: z.object({
                artists: z.object({
                  categories: z.object({
                    accommodation: z.object({ score: z.number() }),
                    catering: z.object({ score: z.number() }),
                    equipment: z.object({ score: z.number() }),
                  }),
                }),
              }),
            })
            .optional(),
        }),
      }),
      stats: z.object({
        eventCount: z.number(),
        co2AveragePerEvent: z.number(),
      }),
    }),
  ),
  events: z.array(
    z.object({
      id: z.number(),
      results: z.object({
        co2: z.object({
          score: z.number(),
        }),
      }),
    }),
  ),
  travels: z.array(
    z.object({
      id: z.number(),
      results: z.object({
        co2: z
          .object({
            score: z.number(),
          })
          .optional(),
      }),
      stats: z.object({
        passengerCount: z.number(),
        weight: z.number(),
      }),
    }),
  ),
});

export const resultsTourDtoSchema = z.object({
  global: globalDtoSchema,
  general: generalDtoSchema,
  ontour: ontourDtoSchema,
});
